module.exports = require("./sq-MK.d.ts");